import FormChooseDesign from '../_DESIGN/FormChooseDesign.jsx'
import {FormItemUeName} from '../UE/FormChooseUe.jsx'
import {FormItemUiName, FormItemUiUserCode} from '../UI/FormChooseUi.jsx'

export default function FormChooseUe(props) {
    return (
        <FormChooseDesign {...props}>
            <FormItemUiUserCode />
            <FormItemUiName />
            <FormItemUeName />
        </FormChooseDesign>
    )
}
